module.exports = __webpack_public_path__ + "media/images/champion-f4412ab6abf9224ba183fd4a1811c4fd.gif";